import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { ReservationCompletePaneState } from './states/ReservationCompletePaneState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { parseQueryParams } from '../../../types/location';
import { ReservationErrorPane } from '../../molecules/reservations/ReservationErrorPane';

type Props = {
    match: {
        params: {
            eventId: string;
        };
    };
};

@observer
export class EventReservationErrorPane extends React.Component<Props> {
    @observable pageState = new ReservationCompletePaneState();
    async componentDidMount() {
        const { eventId } = this.props.match.params;
        await this.pageState.init(Number(eventId));
    }
    render() {
        const { event: eventResource } = this.pageState;
        if (eventResource.isNotFound()) {
            return <NotFoundPage entityType="イベント" />;
        }
        if (eventResource.loading) {
            return <GlobalLoader />;
        }
        const { message } = parseQueryParams(GlobalStatesV3.routing.location);
        return (
            <ReservationErrorPane
                message={message}
                onCompleteClick={() => GlobalStatesV3.routing.push(V3Routes.home())}
            />
        );
    }
}
